import { css } from 'lit';

export const versionViewStyles = css`

  /*=== HOST ===*/

  :host {
    
  }

  view-content {
    
  }

  header-bar .prefix {
    --link-color-default: var(--theme-color-primary-7);
    --link-color-visited: var(--theme-color-primary-7);
    --link-color-focus: var(--theme-color-primary-9);
  }

  p.subtitle.hero {
    --subtitle-color: var(--theme-color-primary-6);
  }

  /*=== RESPONSE FORM ===*/

  q1-md-textarea {
    --label-width: 7rem;
  }

  form button-bar {
    justify-content: flex-end;
  }

  sl-radio-button sl-icon.faux-prefix {
    position: relative;
    left: -8px;
    margin-left: 8px;
  }

  .form-footer {
    margin: 2.5rem 0;
    font-style: italic;
  }

`;
